import {
    GET_GALLERY_IMAGES_SUCCESS,
    SWAP_GALLERY_IMAGES
} from "../../actions/actionTypes";
import initialState from './../initialState';
import GalleryImagesSerializer from "../../services/gallery/GalleryImagesSerializer";

export default function galleryImagesReducer(state = initialState.galleryImages, action) {
    let galleryImages = [];
    switch (action.type) {
        case GET_GALLERY_IMAGES_SUCCESS:
            galleryImages = GalleryImagesSerializer.unserialize(action.galleryImages);
            return [...galleryImages];
            break;

        case SWAP_GALLERY_IMAGES:
            galleryImages =  [...action.galleryImages];
            //change indexes
            let galleryImageATmp = {...galleryImages[action.indexA]};
            galleryImages[action.indexA] = {...galleryImages[action.indexB]};
            galleryImages[action.indexB] = {...galleryImageATmp};
            return [...galleryImages];
            break;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./web/src/reducers/gallery/galleryImagesReducer.js